module.exports = __webpack_public_path__ + "img/20201103.b5e7528b.png";